'use client';

import { c as _c } from "react/compiler-runtime";
import { deleteCookie } from 'cookies-next/client';
import _ from 'lodash';
import { Link, LinkButton } from '@/components';
type Props = {
  error: {
    message?: string;
    status?: number;
  } | unknown;
} & React.ComponentPropsWithoutRef<'div'>;
export function ErrorMessage(t0) {
  const $ = _c(9);
  const {
    error
  } = t0;
  let t1;
  if ($[0] !== error) {
    t1 = error as {
      message?: string;
      status?: number;
    } || {};
    $[0] = error;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    status,
    message
  } = t1;
  if (_.includes(message, "zip code")) {
    deleteCookie("vehicle_loc");
    deleteCookie("vehicle_filter");
  }
  const t2 = status || 500;
  const t3 = message || "Something went wrong";
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <h1 className="text-3xl font-bold tracking-tight text-balance">{t2}: {t3}</h1>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="err-msg">Sorry, an unexpected error has occurred. If the problem persists, please contact{" "}<Link href="mailto:support@cruz.com" useStyle={true}>Cruz Support</Link>.</p>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex justify-center"><nav aria-label="Error Page Navigation" className="mt-10 flex items-center justify-center gap-x-6"><LinkButton href="/" className="rounded-full px-8! h-10" label="Go back home" icon="home" /></nav></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4) {
    t7 = <section className="my-8 flex w-full grow flex-col items-center justify-center text-center" aria-live="assertive">{t4}{t5}{t6}</section>;
    $[7] = t4;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}